module.exports = __webpack_public_path__ + "img/blobs.800b56e.jpg";